<template>
  <div
    class="w100 m-bottom-3"
    style="border-top:1px solid #f5f5f5;height:1px;"
  ></div>
</template>

<script>
export default {
  name: "splitLine",
  data() {
    return {};
  },
};
</script>

<style scoped lang="less" scoped></style>
